import {Component, OnDestroy, OnInit} from "@angular/core";
import {AppService, getStepRoute, Host, Menu, Table, Cart, CartService} from "../../../../common";
import {Router} from "@angular/router";
import {Location} from "@angular/common";
import {Subscription} from "rxjs";

@Component({
  standalone: false,
  template: `
    <checkout-header [host]="host" [cart]="cart"
                     [step]="getNextStep()"
                     (back)="back()" (next)="next()" [canProceed]="canProceed()"></checkout-header>

    <main class="container" *ngIf="cart && menu">
      <div *ngIf="host.has_delivery || host.has_takeout">
        <h5 class="mt-3"><i class="fa fa-ticket-alt"></i>&nbsp;
          <span i18n>Enter Voucher / Discount Code</span>
        </h5>

        <div class="form-group mt-3 mb-3">
          <label for="id_code" i18n>Code*</label>
          <div class="input-group">
            <input id="id_code" type="text" class="form-control hide-validation-status" autofocus
                    autocomplete="off" required
                   [ngClass]="{'is-valid': isValid, 'is-invalid': hasError}"
                   [ngModel]="code" (ngModelChange)="onCodeChange($event)" (blur)="checkCode()">
            <div class="input-group-append">
              <button *ngIf="!isValid && !hasError" class="btn btn-outline-secondary" type="button"
                      (click)="checkCode()"><i class="fas fa-check-circle"></i>&nbsp;<span i18n>check</span></button>
              <button *ngIf="hasError" class="btn btn-outline-secondary" type="button" (click)="clearCode()"><i
                class="fas fa-times-circle"></i>&nbsp;<span i18n>clear</span></button>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3 mb-3 row">
        <div class="col-5 text-left">
          <button class="btn btn-secondary" (click)="back()"><i class="far fa-arrow-alt-circle-left"></i>&nbsp;<span i18n>Back</span>
          </button>
        </div>
        <div class="col-7 text-right">
          <next-step-button [cart]="cart" [step]="getNextStep()" [enabled]="canProceed()"
                            (next)="next()"></next-step-button>
        </div>
      </div>

    </main>
  `,
  styles: [
    `
      #id_code {
        text-align: center;
        font-size: 130%;
        display: inline-block;
        font-family: "Lucida Console", Monaco, monospace;
      }
    `
  ]
})
export class EnterCodePage implements OnInit, OnDestroy {

  host: Host;
  menu: Menu;
  cart: Cart;
  table: Table;
  code: string = "";
  isValid: boolean = false;
  hasError: boolean = false;

  private subscriptions: Array<Subscription> = new Array<Subscription>();

  constructor(
    private router: Router,
    private location: Location,
    private appService: AppService,
    private cartService: CartService,
  ) {

  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.appService.load().subscribe(({host, menu, cart, table}) => {
        this.host = host;
        this.menu = menu;
        this.cart = cart;
        this.table = table;
      })
    );
  }

  clearCode() {
    this.code = "";
    this.isValid = false;
    this.hasError = false;
    return false;
  }

  onCodeChange(code) {
    if (code) {
      this.code = code.toUpperCase();
    }
    this.isValid = false;
    this.hasError = false;
  }

  checkCode() {
    if (this.code) {
      this.cartService.checkDiscountCode(this.code, this.menu)
        .then(
          discount => {
              this.isValid = discount && discount.checkIfApplies(this.cart) > 0;
              this.hasError = !this.isValid;
          }
        ).catch((err) => {
          this.isValid = false;
          this.hasError = true;
        });
    } else {
      this.isValid = false;
      this.hasError = false;
    }
  }

  ngOnDestroy(): void {
    let sub = null;
    while (sub = this.subscriptions.pop()) {
      sub.unsubscribe();
    }
  }

  canProceed() {
    return this.isValid;
  }

  back() {
    this.location.back()
  }

  getNextStep() {
    return this.cart.getNextCheckoutStep();
  }

  next() {
    if (this.canProceed()) {
      if (this.isValid) {
        this.cart.addDiscountCode(this.code).then(() => {
          this.cart.save();
          this.router.navigate(getStepRoute(this.getNextStep()))
        })
      }
    }
  }
}
